module.exports = __webpack_public_path__ + "static/media/claude_ai.f72858f1.png";